module.exports = __webpack_public_path__ + "e195a78e58406740dce7827240064f08.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/logo4.png
 ** module id = 212
 ** module chunks = 1
 **/